export default __webpack_public_path__ + "static/media/emoji_stickers.430165ee.jpg";